export const headerNavItems = [
  { label: '首页', href: '#hero' },
  { label: '最新快讯', href: '#updates' },
  { label: '热门话题', href: '#topics' },
  { label: '用户热评', href: '#comments' },
  { label: 'App下载', href: '#app' },
  { label: '联系我们', href: '#contact' },
];

export const cardsData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20entertainment%20news%20studio%20with%20warm%20red%20and%20gold%20lighting%2C%20modern%20minimalist%20set%20design%20with%20soft%20bokeh%20background%2C%20editorial%20style%20with%20elegant%20composition%2C%20no%20people&width=800&height=600&seq=card-01&orientation=landscape',
    tag: '独家爆料',
    title: '顶流明星深夜密会，新恋情浮出水面',
    summary: '据知情人士透露，某一线顶流近日被拍到深夜现身某高档小区，疑似与圈内女星密会，网友热议不断。',
    date: '2026-07-29',
    views: '128.6万',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20with%20colorful%20dynamic%20lighting%20effects%2C%20entertainment%20studio%20atmosphere%20with%20warm%20spotlights%2C%20modern%20TV%20production%20set%20with%20vibrant%20colors%2C%20no%20people&width=800&height=600&seq=card-02&orientation=landscape',
    tag: '综艺名场面',
    title: '综艺爆笑合集：那些笑到停不下来的名场面',
    summary: '盘点近期综艺节目中最让人捧腹的片段，从意外翻车到即兴发挥，承包你一整天的笑点。',
    date: '2026-07-28',
    views: '96.3万',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20review%20scene%20with%20warm%20amber%20lighting%2C%20movie%20poster%20aesthetic%20with%20dramatic%20shadows%2C%20film%20analysis%20studio%20setting%20with%20professional%20atmosphere%2C%20no%20people&width=800&height=600&seq=card-03&orientation=landscape',
    tag: '影视解说',
    title: '年度最佳悬疑剧深度解析：反转让人头皮发麻',
    summary: '这部国产悬疑剧凭借烧脑剧情和演员炸裂演技成为年度黑马，结局反转让无数观众直呼过瘾。',
    date: '2026-07-27',
    views: '156.2万',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20live%20streaming%20setup%20with%20ring%20light%20and%20smartphone%2C%20digital%20content%20creation%20scene%20with%20warm%20ambient%20lighting%2C%20modern%20influencer%20studio%20aesthetic%2C%20no%20people&width=800&height=600&seq=card-04&orientation=landscape',
    tag: '网红翻车',
    title: '直播事故大合集：网红翻车现场名场面',
    summary: '盘点近期直播圈最尴尬的翻车瞬间，从口误到技术故障，每一个都让人笑到肚子疼。',
    date: '2026-07-26',
    views: '203.7万',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20fashion%20runway%20aesthetic%20with%20warm%20golden%20lighting%2C%20elegant%20red%20carpet%20setting%20with%20glamorous%20atmosphere%2C%20fashion%20event%20photography%20style%20with%20soft%20highlights%2C%20no%20people&width=800&height=600&seq=card-05&orientation=landscape',
    tag: '红毯造型',
    title: '明星红毯造型大盘点：谁是今晚最佳着装？',
    summary: '年度盛典红毯造型全面解析，从高定礼服到珠宝搭配，哪一位的造型最让你惊艳？',
    date: '2026-07-25',
    views: '87.4万',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20breaking%20story%20concept%20with%20dramatic%20warm%20lighting%20and%20newspaper%20headlines%2C%20media%20industry%20atmosphere%20with%20bold%20typography%2C%20editorial%20design%20aesthetic%2C%20no%20people&width=800&height=600&seq=card-06&orientation=landscape',
    tag: '最新爆料',
    title: '娱乐圈本周爆料汇总：你不知道的幕后故事',
    summary: '汇集圈内人士独家爆料，从剧组日常到明星私下状态，带你了解镜头背后最真实的一面。',
    date: '2026-07-24',
    views: '312.5万',
  },
];

export const updatesData = [
  { id: 1, time: '2小时前', title: '某知名导演新片开拍，演员阵容疑似曝光', category: '影视动态' },
  { id: 2, time: '4小时前', title: '热门综艺录制现场突发状况，导演紧急叫停', category: '综艺快报' },
  { id: 3, time: '6小时前', title: '当红小生深夜发长文，疑似回应近期争议', category: '明星动态' },
  { id: 4, time: '8小时前', title: '知名编剧新作定档，题材引发观众热议', category: '影视动态' },
  { id: 5, time: '10小时前', title: '某女星品牌活动造型翻车，网友评论两极分化', category: '娱乐八卦' },
  { id: 6, time: '12小时前', title: '电影票房最新战报：暑期档竞争进入白热化', category: '影视动态' },
  { id: 7, time: '14小时前', title: '综艺节目录制路透流出，嘉宾阵容令人期待', category: '综艺快报' },
  { id: 8, time: '16小时前', title: '网络热梗最新解读：这个梗到底是怎么火起来的', category: '热点追踪' },
  { id: 9, time: '18小时前', title: '多部国产剧集同日官宣定档，网友直呼看不过来', category: '影视动态' },
];

export const topicsData = [
  { id: 1, name: '暑期档电影', heat: '986万', trend: 'up', color: 'bg-primary-100 text-primary-700' },
  { id: 2, name: '顶流恋情', heat: '872万', trend: 'hot', color: 'bg-accent-100 text-accent-800' },
  { id: 3, name: '综艺翻车', heat: '765万', trend: 'up', color: 'bg-secondary-100 text-secondary-800' },
  { id: 4, name: '红毯造型', heat: '654万', trend: 'up', color: 'bg-primary-100/70 text-primary-700' },
  { id: 5, name: '影视解说', heat: '543万', trend: 'stable', color: 'bg-accent-100/70 text-accent-800' },
  { id: 6, name: '直播事故', heat: '498万', trend: 'hot', color: 'bg-secondary-100/80 text-secondary-800' },
  { id: 7, name: '明星日常', heat: '432万', trend: 'up', color: 'bg-primary-100/50 text-primary-700' },
  { id: 8, name: '网剧推荐', heat: '387万', trend: 'stable', color: 'bg-accent-100/50 text-accent-800' },
  { id: 9, name: '娱乐爆料', heat: '356万', trend: 'hot', color: 'bg-secondary-100/60 text-secondary-800' },
  { id: 10, name: '圈内八卦', heat: '321万', trend: 'up', color: 'bg-primary-100/60 text-primary-700' },
];

export const mediaData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20video%20thumbnail%20style%20with%20play%20button%20overlay%2C%20dynamic%20variety%20show%20scene%20with%20colorful%20lighting%2C%20TV%20production%20aesthetic%20with%20warm%20atmosphere%2C%20no%20people&width=800&height=450&seq=media-01&orientation=landscape',
    title: '某顶流密室逃脱被拍，对方身份引猜测',
    duration: '12:35',
    views: '256万',
    tag: '独家',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Film%20commentary%20video%20aesthetic%20with%20cinematic%20color%20grading%2C%20movie%20review%20channel%20style%20with%20dramatic%20warm%20lighting%2C%20professional%20video%20production%20look%2C%20no%20people&width=800&height=450&seq=media-02&orientation=landscape',
    title: '深度解析年度十佳国产电影，你看了几部？',
    duration: '18:42',
    views: '189万',
    tag: '热门',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20highlight%20reel%20aesthetic%20with%20bright%20stage%20lighting%2C%20entertainment%20program%20thumbnail%20style%20with%20vibrant%20colors%2C%20TV%20studio%20atmosphere%2C%20no%20people&width=800&height=450&seq=media-03&orientation=landscape',
    title: '综艺搞笑合集：本季最让人笑到肚子疼的片段',
    duration: '15:20',
    views: '312万',
    tag: '爆款',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20gossip%20news%20video%20style%20with%20dramatic%20lighting%2C%20celebrity%20news%20channel%20aesthetic%20with%20breaking%20news%20theme%2C%20media%20production%20look%20with%20warm%20tonal%20grading%2C%20no%20people&width=800&height=450&seq=media-04&orientation=landscape',
    title: '娱乐圈本周大事件回顾，错过就亏大了',
    duration: '22:08',
    views: '478万',
    tag: '精选',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '实时更新',
    desc: '24小时不间断追踪国内娱乐热点，最新吃瓜内容第一时间呈现，让你永远走在八卦最前沿。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '内容精选',
    desc: '专业编辑团队精心筛选优质国产吃瓜视频，拒绝低质内容，只给你最精彩的娱乐资讯。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '多端畅享',
    desc: '支持手机、平板、电脑多设备在线观看，随时随地畅享国产热门吃瓜视频，追热点不错过。',
  },
];

export const rankingData = [
  { rank: 1, title: '顶流明星深夜密会，新恋情浮出水面', heat: '1286万', change: 'up' },
  { rank: 2, title: '综艺爆笑合集：笑到停不下来的名场面', heat: '1102万', change: 'up' },
  { rank: 3, title: '直播事故大合集：网红翻车现场名场面', heat: '987万', change: 'down' },
  { rank: 4, title: '年度最佳悬疑剧深度解析', heat: '865万', change: 'up' },
  { rank: 5, title: '娱乐圈本周爆料汇总：幕后故事', heat: '743万', change: 'new' },
];

export const faqData = [
  {
    id: 1,
    question: '吃瓜视频的内容更新频率是怎样的？',
    answer: '我们每天更新大量国产吃瓜视频内容，涵盖最新热点事件、综艺片段和影视解说。编辑团队7×24小时追踪国内娱乐动态，确保你不会错过任何一个热点。',
  },
  {
    id: 2,
    question: '吃瓜视频的内容来源可靠吗？',
    answer: '我们的内容均来自国内正规媒体渠道和授权平台，所有国产吃瓜视频经过专业编辑团队的筛选与核实，确保信息真实可靠，为用户提供高质量的娱乐资讯。',
  },
  {
    id: 3,
    question: '如何找到我感兴趣的吃瓜内容？',
    answer: '你可以通过首页的热门话题标签、内容卡片和主题索引快速找到感兴趣的国产吃瓜视频。我们还提供了热度榜单和分类导航，帮助你精准定位想看的内容。',
  },
  {
    id: 4,
    question: '吃瓜视频支持哪些设备观看？',
    answer: '吃瓜视频全面支持手机、平板和电脑等多种设备在线观看。你还可以下载我们的App，随时随地享受国产热门吃瓜视频，获得更流畅的观看体验。',
  },
];

export const indexData = [
  { id: 1, title: '明星恋情', desc: '最新明星恋情动态与深度分析', count: '326篇', icon: 'ri-heart-line' },
  { id: 2, title: '综艺热播', desc: '热门综艺片段与精彩合集', count: '258篇', icon: 'ri-tv-line' },
  { id: 3, title: '影视解说', desc: '深度影视解读与精彩影评', count: '412篇', icon: 'ri-film-line' },
  { id: 4, title: '网红八卦', desc: '直播圈网红最新动态追踪', count: '189篇', icon: 'ri-live-line' },
  { id: 5, title: '红毯时尚', desc: '明星造型盘点与时尚点评', count: '145篇', icon: 'ri-shirt-line' },
  { id: 6, title: '娱乐爆料', desc: '圈内独家爆料与幕后故事', count: '367篇', icon: 'ri-spy-line' },
  { id: 7, title: '热点追踪', desc: '实时热点事件深度跟踪报道', count: '293篇', icon: 'ri-fire-line' },
  { id: 8, title: '搞笑合集', desc: '娱乐搞笑片段与欢乐瞬间', count: '521篇', icon: 'ri-emotion-laugh-line' },
];

export const commentsData = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20colorful%20warm%20tone%20circular%20avatar%20background%20with%20soft%20gradient%2C%20minimalist%20design%2C%20no%20text%20no%20people&width=100&height=100&seq=avatar-01&orientation=squarish',
    name: '吃瓜小能手',
    time: '2小时前',
    content: '这个爆料太劲爆了！完全没想到会是他，坐等后续更多细节曝光。吃瓜视频永远是我获取第一手资讯的首选！',
    likes: 3286,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20amber%20circular%20abstract%20gradient%20avatar%20background%2C%20soft%20geometric%20shapes%2C%20minimalist%2C%20no%20text%20no%20people&width=100&height=100&seq=avatar-02&orientation=squarish',
    name: '娱乐圈观察家',
    time: '5小时前',
    content: '更新速度真的快，刚听说的事这里就有详细报道了。国产吃瓜视频这块做得确实专业，内容质量也很高。',
    likes: 2156,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Coral%20red%20circular%20abstract%20gradient%20avatar%20with%20soft%20warm%20tones%2C%20smooth%20color%20blend%2C%20minimalist%2C%20no%20text%20no%20people&width=100&height=100&seq=avatar-03&orientation=squarish',
    name: '八卦研究所',
    time: '8小时前',
    content: '综艺合集笑死我了，反复看了三遍还是忍不住。期待更多这样的国产吃瓜内容，每天不看都睡不着觉。',
    likes: 4578,
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Golden%20warm%20circular%20abstract%20avatar%20background%20with%20soft%20radial%20gradient%2C%20elegant%20minimalist%2C%20no%20text%20no%20people&width=100&height=100&seq=avatar-04&orientation=squarish',
    name: '追剧达人',
    time: '12小时前',
    content: '影视解说做得很到位，分析特别透彻。通过吃瓜视频发现了不少好剧，现在每天必刷，已经成为习惯了。',
    likes: 1892,
  },
  {
    id: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20peach%20circular%20abstract%20gradient%20avatar%20background%2C%20subtle%20warm%20light%20effect%2C%20minimalist%2C%20no%20text%20no%20people&width=100&height=100&seq=avatar-05&orientation=squarish',
    name: '热梗收集站',
    time: '16小时前',
    content: '每天通勤路上必刷吃瓜视频，内容更新频率真的快。身边朋友都在用，已经安利给整个办公室了。',
    likes: 2734,
  },
];

export const carouselData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20featured%20story%20concept%20with%20dramatic%20warm%20red%20and%20gold%20lighting%2C%20cinematic%20widescreen%20aesthetic%2C%20breaking%20news%20atmosphere%20with%20bold%20visual%20impact%2C%20no%20people&width=1200&height=600&seq=carousel-01&orientation=landscape',
    title: '暑期档票房大战：谁将成为最终赢家？',
    desc: '多部国产大片同期上映，票房竞争进入白热化阶段，各家数据持续刷新纪录。',
    tag: '焦点专题',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20season%20premiere%20concept%20with%20vibrant%20stage%20lighting%2C%20entertainment%20program%20widescreen%20aesthetic%2C%20dynamic%20TV%20production%20atmosphere%20with%20colorful%20visuals%2C%20no%20people&width=1200&height=600&seq=carousel-02&orientation=landscape',
    title: '新一季综艺大战：各家王牌节目全面开播',
    desc: '各大平台王牌综艺悉数回归，新老节目同台竞技，谁能笑到最后？',
    tag: '综艺观察',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Film%20industry%20trends%20concept%20with%20cinematic%20warm%20amber%20lighting%2C%20movie%20production%20widescreen%20aesthetic%2C%20dramatic%20film%20atmosphere%20with%20professional%20look%2C%20no%20people&width=1200&height=600&seq=carousel-03&orientation=landscape',
    title: '国产剧集质量飙升：今年这些剧值得追',
    desc: '盘点本年度口碑与热度双丰收的国产剧集，从悬疑到都市，类型全面开花。',
    tag: '影视盘点',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20trending%20topics%20concept%20with%20warm%20golden%20lighting%2C%20internet%20culture%20widescreen%20aesthetic%2C%20digital%20trend%20atmosphere%20with%20modern%20visual%20style%2C%20no%20people&width=1200&height=600&seq=carousel-04&orientation=landscape',
    title: '网络热梗背后的故事：从诞生到出圈',
    desc: '深度追踪近期最火的网络热梗，剖析其背后的传播逻辑与文化现象。',
    tag: '深度报道',
  },
];